import { PartialTranslation } from '../translations';

export const tl: PartialTranslation = {
  newChat: 'Bagong chat',
  search: 'Maghanap',
  user: 'User',
  settings: 'Mga Setting',
  language: 'Wika',
  getHelp: 'Kumuha ng Tulong',
  viewAllPlans: 'Tingnan ang Lahat ng Plano',
  learnMore: 'Matuto Pa',
  logOut: 'Mag-logout',
  chooseLanguage: 'Pumili ng Wika',
  chooseYourPreferredLanguage: 'Piliin ang inyong mas gustong wika',
  searchLanguages: 'Maghanap ng mga wika...',
  autoDetect: 'Awtomatikong Pagkakakilala',
  noLanguagesFound: 'Walang nahanap na wika',
  askAnything: 'Magtanong ng kahit ano',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personal',
  freePlan: 'Libreng plano',
  current: 'Kasalukuyan',
  close: 'Isara',
  archive: 'I-archive',
  delete: 'Tanggalin',
  confirmDelete: 'Sigurado ka bang gusto mong tanggalin ang chat na ito?',
  confirmArchive: 'Sigurado ka bang gusto mong i-archive ang chat na ito?',
  deleteCannotUndo: 'Hindi na maaaring ibalik ang aksyong ito.',
  archiveCanFind: 'Mahahanap mo ito sa archive list pagkatapos i-archive.',
  // 资源面板
  resources: 'Mga Mapagkukunan',
  addResource: 'Magdagdag ng Resource',
  deleteResource: 'Tanggalin ang Resource',
  noMatchingResourcesFound: 'Walang nahanap na tugmang resources',
  noResourcesAvailable: 'Walang available na resources',
  hideResources: 'Itago ang mga Resources',
  showResources: 'Ipakita ang mga Resources',
  
  // 聊天输入框
  typeMessage: 'Mag-type ng mensahe...',
  thinkingOptions: 'Mga pagpipilian sa pag-iisip',
  deleteFile: 'Tanggalin ang file',
  clearSelection: 'Linisin ang napili',
  
  // 思考模式选项
  deepInsight: 'Malalim na Pag-unawa · Panlabas na Pagsusuri',
  deepInsightDesc: 'Mabilis na pag-unawa sa mga pangunahing punto',
  deepExploration: 'Malalim na Paggalugad · Komprehensibong Pagsusuri',
  deepExplorationDesc: 'Multi-dimensional na malalim na pananaliksik',
  deepDeconstruction: 'Malalim na Pagkakawatak-watak · Sistematikong Argumento',
  deepDeconstructionDesc: 'Paulit-ulit na progresibong pagsusuri',
  
  // 写作模式选项
  contractReview: 'Pagrepaso ng Kontrata · Pagkilala sa Panganib',
  contractReviewDesc: 'Pagsusuri ng mga klausula at pagsusuri ng compliance',
  textPolish: 'Pagpapaganda ng Teksto · Propesyonal na Pagpapahayag',
  textPolishDesc: 'Pag-optimize ng wika at pag-adjust ng istruktura',
  legalDocuments: 'Mga Legal na Dokumento · Standard na Paggawa',
  legalDocumentsDesc: 'Propesyonal na pagsusulat ng legal na dokumento',
  addAttachment: 'Magdagdag ng Attachment',
  sendMessage: 'Ipadala ang Mensahe',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Mag-log in',
  register: 'Mag-sign up',
  welcomeBack: 'Maligayang pagdating sa LawHelper',
  loginSubtitle: 'Ang iyong AI Legal Research Assistant',
  continueWithGoogle: 'Magpatuloy sa Google',
  continueWithMicrosoft: 'Magpatuloy sa Microsoft',
  continueWithWeChat: 'Magpatuloy sa WeChat',
  orContinueWith: 'o magpatuloy sa',
  emailTab: 'Email',
  phoneTab: 'Telepono',
  emailPlaceholder: 'Ilagay ang iyong email',
  phonePlaceholder: 'Ilagay ang numero ng telepono',
  codePlaceholder: 'Ilagay ang 6-digit na code',
  sending: 'Nagpapadala...',
  verifying: 'Bine-verify...',
  verify: 'I-verify',
  sendMagicLink: 'Magpadala ng magic link',
  getVerificationCode: 'Kunin ang code',
  resendCode: 'Ipadala muli ang code',
  resendIn: 'Ipadala muli sa',
  magicLinkSent: 'Naipadala na ang magic link sa iyong email',
  magicLinkHint: 'Magpapadala kami ng secure na link sa iyong email',
  otpSent: 'Naipadala na ang verification code',
  agreeToTerms: 'Sa pagpapatuloy, sumasang-ayon ka sa',
  privacyPolicy: 'Patakaran sa Privacy',
  termsOfService: 'Mga Tuntunin ng Serbisyo',
  and: 'at',
  privacyTitle: 'Mahalaga ang iyong privacy',
  privacyIntro: 'Gumagamit kami ng cookies at katulad na teknolohiya para ibigay ang pinakamahusay na karanasan.',
  essentialCookies: 'Mahahalagang cookies',
  essentialDesc: 'Kinakailangan para gumana ang website',
  analyticsCookies: 'Analytics cookies',
  analyticsDesc: 'Tumutulong sa pagpapabuti ng serbisyo',
  marketingCookies: 'Marketing cookies',
  marketingDesc: 'Ginagamit para sa personalized na content',
  acceptAll: 'Tanggapin lahat',
  essentialOnly: 'Mahalaga lamang',
  customize: 'I-customize',
  savePreferences: 'I-save ang mga kagustuhan',
  back: 'Bumalik',
  readPrivacyPolicy: 'Basahin ang aming patakaran sa privacy',
  cookiePolicy: 'Patakaran sa Cookie',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI Pagsusuri',
  aiDraft: 'AI Draft',
  smartAssistant: 'Template',

  // 知识库搜索
  enableKnowledgeSearch: 'I-enable ang paghahanap',
  knowledgeSearchDesc: 'Ang AI ay naghahanap sa iyong mga dokumento',
  clickToDisable: 'I-disable',
  clickToEnable: 'I-enable',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Isara ang panel ng mapagkukunan',
  uploading: 'Ina-upload ang %{fileName}...',
  processing: 'Pinoproseso ang %{fileName}...',
  uploadSuccess: '✓ Na-upload na ang %{fileName}',
  uploadError: '✗ Nabigong mag-upload: %{error}',
  quickAnswer: 'Mabilis na Sagot',
  quickAnswerDesc: 'Mabilis na sagot sa simpleng mga tanong',
  cancelRequest: 'Kanselahin',
  library: 'Aklatan',
  filterAll: 'Lahat',
  filterChat: 'Chat',
  filterReview: 'Pagsusuri',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'Nag-iisip...',
  thinkingProcess: 'Proseso ng pag-iisip',
  analyzingLegalLogic: 'Sinusuri ang legal na lohika...',
  lawhelperThinking: 'Nag-iisip ang Lawhelper...',
  serviceError: 'Error sa serbisyo',
  uploaded: 'Na-upload na',
  settingsGeneral: 'Pangkalahatan',
  settingsNotifications: 'Mga Abiso',
  settingsAppearance: 'Hitsura',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Mode ng kulay',
  settingsLight: 'Maliwanag',
  settingsDark: 'Madilim',
  settingsSystem: 'Sistema',
  about: 'Tungkol sa',
  reviewTitle: 'Pagsusuri ng Dokumento',
  exitReview: 'Umalis sa pagsusuri',
  uploadPrompt: 'Mag-upload ng PDF para suriin',
  uploadButton: 'Pumili ng file',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Sinusuri...',
  reviewComplete: 'Tapos na ang pagsusuri',
  issuesFound: 'Nakita ang %{count} na problema',
  draftTitle: 'Pag-draft ng Legal na Dokumento',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Gumagawa...',
  generatedSuccess: '✅ Nagawa na ang dokumento!',
  drafterWelcome: 'Maligayang pagdating sa AI Document Assistant',
  drafterYouCan: 'Maaari mong:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Mga Halimbawa:',
  drafterExampleRental: '"Gumawa ng kontrata sa upa"',
  drafterExampleLabor: '"Punan ang kontrata sa trabaho"',
  drafterInputPlaceholder: 'Ilarawan ang iyong mga pangangailangan...',
  drafterThinking: 'Nag-iisip...',
  drafterHistoryTitle: 'Kasaysayan',
  drafterNoHistory: 'Walang kasaysayan',
  drafterNewChat: 'Bagong chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'I-save ang dokumento',
  drafterDownload: 'I-download ang dokumento',
  drafterUndo: 'I-undo',
  drafterRedo: 'I-redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Lumabas',
  drafterConfirm: 'Kumpirmahin',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Tumatakbo...',
  workflowReady: 'Handa na',
  workflowCompleted: 'Tapos na',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Tanggapin ang mga pagbabago',
  rejectChanges: 'Tanggihan ang mga pagbabago',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Ihinto',
  restartWorkflow: 'Restart',
  startDrafting: 'Simulan ang pag-draft',
  interrupt: 'Stop',
  documentSubject: 'Paksa ng dokumento *',
  documentType: 'Uri ng dokumento',
  jurisdiction: 'Hurisdiksyon',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Kontrata',
  docTypeAgreement: 'Kasunduan',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Sulat',
  docTypePetition: 'Petition',
  docTypeWill: 'Testamento',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'Tsina',
  countryUSA: 'Estados Unidos',
  countryGermany: 'Alemanya',
  countryJapan: 'Hapon',
  countryFrance: 'Pransya',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Smart Document Assistant',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Pumili ng file',
  smartDocOr: 'o',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Error',
  unknownError: 'Hindi kilalang error',
  file: 'File',
  loading: 'Naglo-load...',
  localFolders: 'Lokal na mga folder',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'I-save',
  renameFile: 'Palitan ang pangalan',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI Analysis',
};
